import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67aa5b3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "search_container" }
const _hoisted_3 = { class: "search_box" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = { class: "create_box" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("新建")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("配置")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取链")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableLayout = _resolveComponent("TableLayout")!
  const _component_add_dialog = _resolveComponent("add-dialog")!
  const _component_dispose_dialog = _resolveComponent("dispose-dialog")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_TableLayout, null, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.searchHandle.client,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchHandle.client) = $event)),
                class: "search_input",
                placeholder: "所属产品"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchHandle.clientList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.text,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.searchHandle.status,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchHandle.status) = $event)),
                class: "search_input",
                placeholder: "状态"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchHandle.statusList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.text,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.searchHandle.template,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchHandle.template) = $event)),
                class: "search_input",
                placeholder: "活动模板"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchHandle.templateList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.text,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_input, {
                modelValue: _ctx.searchHandle.name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchHandle.name) = $event)),
                class: "search_input",
                placeholder: "活动名称"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: _ctx.tableHandle.loadList
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                size: "small",
                onClick: _ctx.searchHandle.reset
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              class: "new_btn",
              onClick: _ctx.dialogHandle.showAddActivity
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        main: _withCtx(() => [
          _createVNode(_component_el_table, {
            height: "100%",
            border: "",
            data: _ctx.tableHandle.list,
            class: "table_box"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "70",
                prop: "id",
                label: "广告id"
              }),
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "活动名称"
              }),
              _createVNode(_component_el_table_column, {
                prop: "code",
                label: "活动标识"
              }),
              _createVNode(_component_el_table_column, {
                prop: "client_type",
                label: "所属产品"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.ClientTypeByLabelMap[scope.row.client_type]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "template",
                label: "活动模版"
              }),
              _createVNode(_component_el_table_column, {
                width: "180",
                prop: "start_time",
                label: "开始时间"
              }),
              _createVNode(_component_el_table_column, {
                width: "180",
                prop: "end_time",
                label: "结束时间"
              }),
              _createVNode(_component_el_table_column, {
                width: "180",
                prop: "create_time",
                label: "创建时间"
              }),
              _createVNode(_component_el_table_column, {
                width: "60",
                label: "状态"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.StatusActivityLabelMap[scope.row.status]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "280",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.tableHandle.edit(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "success",
                    onClick: ($event: any) => (_ctx.tableHandle.dispose(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "danger",
                    onClick: ($event: any) => (_ctx.tableHandle.delete(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.tableHandle.copyLink(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_el_pagination, {
            align: "right",
            "current-page": _ctx.paginationHandle.page,
            "page-size": _ctx.paginationHandle.size,
            total: _ctx.paginationHandle.total,
            onSizeChange: _ctx.paginationHandle.handleSizeChange,
            onCurrentChange: _ctx.paginationHandle.handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
        ]),
        _: 1
      }),
      (_ctx.dialogHandle.visible)
        ? (_openBlock(), _createBlock(_component_add_dialog, {
            key: 0,
            activity: _ctx.tableHandle.activitySelect,
            onClose: _ctx.dialogHandle.close,
            onSumbit: _ctx.tableHandle.reload
          }, null, 8, ["activity", "onClose", "onSumbit"]))
        : _createCommentVNode("", true),
      (_ctx.dialogHandle.visibleDispose)
        ? (_openBlock(), _createBlock(_component_dispose_dialog, {
            key: 1,
            activity: _ctx.tableHandle.activitySelect,
            onClose: _ctx.dialogHandle.close,
            onSumbit: _ctx.tableHandle.reload
          }, null, 8, ["activity", "onClose", "onSumbit"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}